import { Component, HostListener, OnInit } from '@angular/core';
import config from '././config/config';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent  implements OnInit{
  fixed: boolean=false;
  apiUrl: string;
  contactDetails: any;
  constructor( private http: HttpClient) 
  {
    this.apiUrl = config.API_ENDPOINT
  }

	@HostListener('window:scroll', ['$event'])
	onWindowScroll(e:any)
	{
	  if (window.pageYOffset > 150) 
	  {
		this.fixed = true;
	  } 
	  else
	  {
		this.fixed = false;
	  }
  } 
  getcontactInfo()
  {
	this.http.get(`${this.apiUrl}/staticdata/getContactDetails`).subscribe((res: any) => {
        this.contactDetails = res;
      
    })
  }
  ngOnInit()
  {
	this.getcontactInfo();
  }
}
